import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const HighTech = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
  <div className="banner-overlay1"></div>
  <div className="banner-content">
    <h6 className="banner-subtitle">Services / High Tech</h6>
    <hr />
    <h1 className="banner-title">
      Drive Innovation in the <br /> High-Tech Industry with Cutting-Edge Solutions
    </h1>
    <p>
      Leverage advanced technology solutions to <br /> enhance product development, optimize operations, and stay ahead in the rapidly evolving high-tech landscape.
    </p>
    <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
  </div>

  <img
    className="banner-image"
    src="https://img.freepik.com/free-photo/adult-man-young-women-working-together_23-2148431338.jpg"
    alt="High Tech Solutions"
  />
</section>

<section id="about" className="about py-5">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h6 className="col_yell text-center">High Tech</h6>
        <h2 className="text-center">
          Pioneering the Future with Advanced High-Tech Solutions
        </h2>
        <p className="text-center">
          The high-tech industry is constantly evolving, and we provide innovative software solutions that enable companies to stay ahead. From product development to supply chain optimization, our data-driven tools help high-tech businesses achieve operational excellence and drive innovation. With a focus on automation, AI, and IoT, we help companies streamline processes, reduce costs, and accelerate growth.
        </p>
      </div>
    </div>
  </div>
</section>

<hr />

<div className="container-fluid" style={{ padding: 40 }}>
  <div className="row serv_h1 mb-4">
    <div className="col-md-12">
      <div className="serv_h1l mb-4">
        <h2 className="text-center">High Tech Solutions</h2>
        <p className="text-center mb-0">
          Harness the power of technology to drive innovation and operational efficiency in the high-tech sector.
        </p>
      </div>
    </div>
  </div>

  <div className="row g-4">
    <div className="col-md-6">
      <div className="p-4 border rounded bg-white card-hover">
        <h3 className="mb-3 card-title">
          <a href="#">AI & Machine Learning</a>
        </h3>
        <p className="mb-4">
          Leverage artificial intelligence and machine learning to optimize decision-making and improve business processes.
        </p>
      </div>
    </div>

    <div className="col-md-6">
      <div className="p-4 border rounded bg-white card-hover">
        <h3 className="mb-3 card-title">
          <a href="#">IoT Solutions</a>
        </h3>
        <p className="mb-4">
          Enable smarter operations with IoT-driven solutions for real-time monitoring and automation.
        </p>
      </div>
    </div>

    <div className="col-md-6">
      <div className="p-4 border rounded bg-white card-hover">
        <h3 className="mb-3 card-title">
          <a href="#">Cloud Computing</a>
        </h3>
        <p className="mb-4">
          Scale your operations seamlessly with robust cloud infrastructure and services.
        </p>
      </div>
    </div>

    <div className="col-md-6">
      <div className="p-4 border rounded bg-white card-hover">
        <h3 className="mb-3 card-title">
          <a href="#">Automation Solutions</a>
        </h3>
        <p className="mb-4">
          Automate tasks and boost efficiency with advanced tools.
        </p>
      </div>
    </div>
  </div>
</div>

<hr />

<section id="serv_h" className="p_3">
  <div className="container-xl">
    <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
      <div className="col-md-8">
        <div className="serv_h3l">
          <h2>
            Ready to Transform Your High-Tech Operations?
          </h2>
          <p className="mt-3">
            Let’s explore how our advanced technology solutions can drive innovation and operational excellence in your business.
          </p>
          <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
        </div>
      </div>
      <div className="col-md-4">
        <div className="serv_h3r">
          <div className="grid clearfix">
            <figure className="effect-jazz mb-0">
              <Link to="/contact">
                <img
                  src="https://img.freepik.com/free-photo/medium-shot-two-colleagues-discussing-business-office_1098-17855.jpg"
                  className="w-100"
                  alt="Consultation"
                />
              </Link>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};

export default HighTech;
